import { XHSPX_ADDRESS } from '@hyperswap/addresses'
import { useActiveWeb3React } from '.'
import { getContract } from '../utils'
import { useEffect, useState } from 'react'
import { abi as XGrailTokenABI } from '../abis/x-grail-token.json'

const useVestingXToken = () => {
  const { active, account, library, chainId } = useActiveWeb3React()

  const [data, setData] = useState<any>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchData = async () => {
      //address: string, ABI: any, library: Web3Provider, account?: string
      if (active && loading && account && chainId && library) {
        const xtokenContract = getContract(XHSPX_ADDRESS, XGrailTokenABI, library, account)

        try {
          setLoading(true)
          const indexLength = await xtokenContract.getUserRedeemsLength(account)

          const dataList: any = []

          for (let i = 0; i < indexLength.toNumber(); i++) {
            const positionData = await xtokenContract.getUserRedeem(account, i)

            dataList.push(positionData)
          }

          setData(dataList)
          setLoading(false)
        } catch (error) {
          console.error('Error fetching pools:', error)
        } finally {
          setLoading(false)
        }
      }
    }

    fetchData()
  }, [active, loading, chainId, account, library])

  return {
    data: data,
    loading,
    refresh: () => {
      setLoading(true)
    },
  }
}

export default useVestingXToken
